import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
export const Parent = styled.div `
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 8px 0 32px;
`;
export const Section = styled.div `
    background-color: ${colors.black_4};
    border-radius: 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
export const SectionHeader = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: 600;
`;
export const FormRow = styled.div `
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;
`;
export const Field = styled.label `
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: ${fontSizes.SMALL};
    flex: 1 1 220px;
`;
export const Input = styled.input `
    padding: 8px 10px;
    border: 1px solid ${colors.black_30};
    border-radius: 6px;
    font-size: ${fontSizes.STANDARD};
`;
export const TextArea = styled.textarea `
    padding: 8px 10px;
    border: 1px solid ${colors.black_30};
    border-radius: 6px;
    font-family: monospace;
    font-size: ${fontSizes.SMALL};
    resize: vertical;
`;
export const Select = styled.select `
    padding: 8px 10px;
    border: 1px solid ${colors.black_30};
    border-radius: 6px;
    font-size: ${fontSizes.STANDARD};
`;
export const Table = styled.table `
    width: 100%;
    border-collapse: collapse;
    font-size: ${fontSizes.SMALL};
`;
export const Th = styled.th `
    text-align: left;
    padding: 6px 10px;
    border-bottom: 1px solid ${colors.black_30};
    white-space: nowrap;
`;
export const Td = styled.td `
    padding: 6px 10px;
    border-bottom: 1px solid ${colors.black_10};
    vertical-align: top;
`;
export const ClickableRow = styled.tr `
    cursor: pointer;
    &:hover {
        background-color: ${colors.blue_5};
    }
    &[data-selected="true"] {
        background-color: ${colors.blue_10};
    }
`;
export const Panes = styled.div `
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
`;
export const Pane = styled.div `
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
`;
export const PaneTitle = styled.div `
    font-size: ${fontSizes.SMALL};
    font-weight: 600;
`;
export const PaneHeader = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;
export const CopyBtn = styled.button `
    border: 1px solid ${colors.black_30};
    background-color: #ffffff;
    border-radius: 4px;
    font-size: 10px;
    padding: 2px 8px;
    cursor: pointer;
    white-space: nowrap;
    &:hover {
        background-color: ${colors.black_4};
    }
`;
export const JsonPre = styled.pre `
    margin: 0;
    background-color: ${colors.black_8};
    padding: 10px;
    border-radius: 6px;
    font-size: 11px;
    line-height: 1.4;
    max-height: 360px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-word;
`;
export const Meta = styled.div `
    font-size: ${fontSizes.SMALL};
    color: ${colors.black_30};
`;
export const ReviewItem = styled.div `
    font-size: ${fontSizes.SMALL};
    padding: 8px 10px;
    background-color: #ffffff;
    border: 1px solid ${colors.black_10};
    border-radius: 6px;
`;
export const ErrorMsg = styled.div `
    padding: 10px 12px;
    border-radius: 6px;
    background-color: #fdecea;
    color: #b00020;
    font-size: ${fontSizes.SMALL};
`;
export const SuccessMsg = styled.div `
    padding: 10px 12px;
    border-radius: 6px;
    background-color: ${colors.blue_5};
    color: ${colors.blue_50};
    font-size: ${fontSizes.SMALL};
`;
